import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import Background from "../Background";
import Borders from "../Borders";
import Size from "../Size";
import Spacing from "../Spacing";



const StyleContainer = ({ parent }: EditableProps) => {
    
    return (
        <SidebarCollapse title="Container" parent={parent}>
            <Size noWrapper/>
            <Background noWrapper/>
            <Borders noWrapper/>
            <Spacing noWrapper
            />
        </SidebarCollapse>
    );
};

export default StyleContainer;
